import { useMemo } from "react";
import { useGameStore } from "@/store/gameStore";
import { useUiStore } from "@/store/uiStore";
import { formatEvent } from "@/utils/formatEvent";

export default function LogPanel() {
  const state = useGameStore((s) => s.state);
  const view = useUiStore((s) => s.view);
  const showLog = useUiStore((s) => s.showLog);
  const toggleLog = useUiStore((s) => s.toggleLog);
  const autoSkip = useGameStore((s) => s.autoSkipEmptyResponse);
  const setAutoSkip = useGameStore((s) => s.setAutoSkipEmptyResponse);

  const lines = useMemo(() => {
    if (!state) return [] as string[];
    const names = new Map(state.players.map((p) => [p.id, p.hero.name]));
    return state.log
      .slice(-20)
      .reverse()
      .map((e) => formatEvent(e, names))
      .filter((t): t is string => Boolean(t));
  }, [state]);

  if (view === "mobile") {
    return (
      <>
        <button className="log-fab" onClick={toggleLog} aria-label="事件日志">
          日志
        </button>
        <div
          className={`log-drawer${showLog ? " log-drawer--open" : ""}`}
        >
          <div className="log-drawer__header">
            <div className="log-drawer__head-left">
              <span>事件日志</span>
              <label className="log-panel__autoskip">
                <input
                  type="checkbox"
                  checked={autoSkip}
                  onChange={(e) => setAutoSkip(e.target.checked)}
                />
                自动跳过空响应
              </label>
            </div>
            <button
              className="log-drawer__close"
              onClick={toggleLog}
              aria-label="关闭"
            >
              ×
            </button>
          </div>
          <div className="log-list">
            {lines.length === 0 ? (
              <div className="log-line">暂无事件</div>
            ) : (
              lines.map((l, i) => (
                <div key={i} className="log-line">
                  {l}
                </div>
              ))
            )}
          </div>
        </div>
      </>
    );
  }

  return (
    <div className="log-panel">
      <div className="log-panel__title">
        <span>事件日志</span>
        <label className="log-panel__autoskip" title="勾选后：响应窗口所有响应者无可响应牌时立即跳过（会泄露「无牌」信息）">
          <input
            type="checkbox"
            checked={autoSkip}
            onChange={(e) => setAutoSkip(e.target.checked)}
          />
          自动跳过空响应
        </label>
      </div>
      <div className="log-list">
        {lines.length === 0 ? (
          <div className="log-line">暂无事件</div>
        ) : (
          lines.map((l, i) => (
            <div key={i} className="log-line">
              {l}
            </div>
          ))
        )}
      </div>
    </div>
  );
}
